import React from 'react';
import blogCover from '../images/b2.png';
import blogCover2 from '../images/blog16.png';
import OurPartner from '../pages/components/OurPartner';
import SuggestedBlogs from './components/SuggestedBlogs';

import { FaUser, FaCalendarAlt, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { features } from "./components/BlogSection";
import { Link } from "react-router-dom";

const currentIndex = features.findIndex(
    (blog) => blog.link === "/ai-in-web-application-development"
);

const prevBlog = features[currentIndex - 1];
const nextBlog = features[currentIndex + 1];

function AIInWebApplicationDevelopment() {

    const postDate = "July 24, 2026";

    return (
        <>
            {/* BLOG HEADER */}
            <section className="container my-5">

                <div className="text-center mb-4">

                    <h1 className="fw-bold responsive-heading mb-3">
                        <span className="highlight-orange">
                            How Peregrinee Uses AI in Web Application Development
                        </span>
                    </h1>

                    <p className="mt-3 text-muted fs-5">
                        Explore how Peregrinee integrates artificial intelligence into web
                        applications to deliver smarter automation, predictive insights,
                        and enhanced user experiences.
                    </p>

                    <div className="d-flex justify-content-center align-items-center gap-4 mt-3 text-muted">

                        <span className="d-flex align-items-center gap-2">
                            <FaUser />
                            Posted by <strong>Peregrinee</strong>
                        </span>

                        <span className="d-flex align-items-center gap-2">
                            <FaCalendarAlt />
                            {postDate}
                        </span>

                    </div>

                </div>

            </section>


            {/* HERO IMAGE */}
            <section className="container mb-5">

                <img
                    src={blogCover}
                    alt="AI Web Application Development"
                    className="img-fluid rounded-4 shadow w-100"
                    style={{ maxHeight: "500px", objectFit: "cover" }}
                />

            </section>


            {/* SECTION 1 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6">

                        <img
                            src={blogCover}
                            alt="Artificial Intelligence Integration"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                    <div className="col-lg-6">

                        <h3 className="fw-bold highlight-orange">
                            The Role of AI in Modern Web Applications
                        </h3>

                        <p>
                            Artificial intelligence is transforming how modern
                            web applications operate. AI enables systems to
                            analyze data, automate workflows, and deliver
                            personalized experiences for users.
                        </p>

                        <h3 className="fw-bold highlight-orange mt-4">
                            Key AI Capabilities
                        </h3>

                        <ul className="ps-3">
                            <li>Machine learning-based decision making</li>
                            <li>Predictive analytics</li>
                            <li>Natural language processing</li>
                            <li>Automated data processing</li>
                            <li>Smart recommendation systems</li>
                        </ul>

                        <p className="mt-3">
                            These capabilities help businesses build smarter
                            and more responsive digital platforms.
                        </p>

                    </div>

                </div>

            </section>


            {/* SECTION 2 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6 order-lg-1 order-2">

                        <h3 className="fw-bold highlight-orange">
                            AI Features Peregrinee Implements
                        </h3>

                        <p>
                            Peregrinee integrates AI features into web
                            applications to enhance automation and
                            decision-making capabilities.
                        </p>

                        <ul className="ps-3">
                            <li>AI chatbots for customer support</li>
                            <li>Recommendation engines for eCommerce</li>
                            <li>Fraud detection systems</li>
                            <li>Smart data analytics dashboards</li>
                            <li>AI-powered content personalization</li>
                        </ul>

                        <p className="mt-3">
                            These features improve operational efficiency
                            while delivering better user experiences.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold mt-3"
                            style={{ width: "fit-content" }}
                        >
                            Discuss AI Integration
                        </a>

                    </div>

                    <div className="col-lg-6 order-lg-2 order-1">

                        <img
                            src={blogCover2}
                            alt="AI Technology in Web Apps"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                </div>

            </section>


            {/* SECTION 3 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Benefits of AI in Web Applications
                </h2>

                <ul className="ps-3">
                    <li>Automation of repetitive business processes</li>
                    <li>Better customer engagement and personalization</li>
                    <li>Data-driven decision making</li>
                    <li>Improved operational efficiency</li>
                    <li>Advanced predictive analytics</li>
                </ul>

                <p className="mt-3">
                    AI-powered web applications enable companies to scale
                    operations while improving service quality.
                </p>

            </section>


            {/* SECTION 4 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Industries Using AI Web Applications
                </h2>

                <ul className="ps-3">
                    <li>Fintech platforms</li>
                    <li>Healthcare applications</li>
                    <li>eCommerce platforms</li>
                    <li>EdTech systems</li>
                    <li>Customer service platforms</li>
                </ul>

                <p className="mt-3">
                    Businesses across industries are adopting AI to
                    create smarter digital products.
                </p>

            </section>


            {/* SECTION 5 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Future of AI in Web Development
                </h2>

                <p>
                    AI will continue to play a major role in the future
                    of web applications, enabling intelligent automation,
                    advanced analytics, and highly personalized user
                    experiences.
                </p>

                <p>
                    Peregrinee focuses on building AI-enabled web
                    applications that help businesses innovate and
                    stay competitive in a rapidly evolving digital
                    landscape.
                </p>

                <div className="text-center mt-4">

                    <a
                        href="/contact-us"
                        className="btn btn-orange rounded-pill px-5 py-3 fw-bold"
                        style={{ width: "fit-content" }}
                    >
                        Build an AI-Powered Web Application
                    </a>

                </div>

            </section>


            {/* BLOG NAVIGATION */}
            <section className="container my-5">

                <div className="row">

                    {prevBlog && (
                        <div className="col-md-6 mb-3">

                            <Link
                                to={prevBlog.link}
                                className="d-flex align-items-center gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <FaArrowLeft />

                                <div>
                                    <small className="text-muted">Previous Blog</small>
                                    <h6 className="mb-0 fw-bold">{prevBlog.title}</h6>
                                </div>

                            </Link>

                        </div>
                    )}

                    {nextBlog && (
                        <div className="col-md-6 mb-3 text-md-end">

                            <Link
                                to={nextBlog.link}
                                className="d-flex align-items-center justify-content-md-end gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <div>
                                    <small className="text-muted">Next Blog</small>
                                    <h6 className="mb-0 fw-bold">{nextBlog.title}</h6>
                                </div>

                                <FaArrowRight />

                            </Link>

                        </div>
                    )}

                </div>

            </section>


            <SuggestedBlogs />

            <OurPartner />

        </>
    );
}

export default AIInWebApplicationDevelopment;